var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h4",
              { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("group.editModal.externalUsers.parseModal.title")
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("div", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("group.editModal.externalUsers.parseModal.note")
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("DropZone", {
                attrs: {
                  formId: "uploadModal" + _vm.uid,
                  url: _vm.dropzoneUrl
                },
                on: {
                  uploaded: function($event) {
                    return _vm.$emit("parsed", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "my-4" })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }